import { render, staticRenderFns } from "./search-header.vue?vue&type=template&id=106083a6&"
import script from "./search-header.vue?vue&type=script&lang=js&"
export * from "./search-header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports